import type React from 'react'

type Props = {
  size?: number
}

const IconRight: React.FC<Props> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.75">
      <path
        d="M9.17188 2.95508L14.3281 7.87695C14.4746 8.02344 14.5625 8.19922 14.5625 8.4043C14.5625 8.58008 14.4746 8.75586 14.3281 8.90234L9.17188 13.8242C8.9082 14.0879 8.43945 14.0879 8.17578 13.7949C7.91211 13.5312 7.91211 13.0625 8.20508 12.7988L12.1016 9.10742H2.14062C1.73047 9.10742 1.4375 8.78516 1.4375 8.4043C1.4375 7.99414 1.73047 7.70117 2.14062 7.70117H12.1016L8.20508 3.98047C7.91211 3.7168 7.91211 3.24805 8.17578 2.98438C8.43945 2.69141 8.87891 2.69141 9.17188 2.95508Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export default IconRight
